import React, { useState, useEffect } from 'react';
import * as Helpers from './BillboardListView.helpers';
import { employeeDashboardStore as store } from '../../../../store';
import Table from './Table';
import TableHeader from './TableHeader';
import './BillboardListView.scss';

/**
 * @param {{
*  handleShiftClick?: (rowData: Helpers.IListViewItem, event: *) => void;
*  handleMultiSelectShift?: (rowData: Helpers.IListViewItem, event: *) => void;
*  handleMultiSelectOpenShift?: (rowData: Helpers.IListViewItem, event: *) => void;
*  isRowSelectionDisabled?: boolean;
*  fillAvailableHeight: boolean;
*  height?: number;
* } & import('rsuite-table').TableProps} param0
*/
const BillboardListView = ({
    handleShiftClick = () => {},
    handleMultiSelectShift = () => {},
    handleMultiSelectOpenShift = () => {},
    isRowSelectionDisabled,
    fillAvailableHeight,
    height,
}) => {
    const { data: storeData, selectedShifts, selectedOpenShifts } = store.getState();
    const { monthlySchedule } = storeData;
    const [checkedKeys, setCheckedKeys] = useState([
        ...selectedShifts.map(Helpers.getShiftRowKey),
        ...selectedOpenShifts.map(Helpers.getOpenShiftRowKey)]);
    const [isDisplaySegmentInfos, setIsDisplaySegmentInfos] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [originalParsedListItems, setOriginalParsedListItems] = useState(Helpers.toListView(monthlySchedule));
    const [filteredListItems, setFilteredListItems] = useState(originalParsedListItems);

    useEffect(() => {
        setCheckedKeys([...selectedShifts.map(Helpers.getShiftRowKey), ...selectedOpenShifts.map(Helpers.getOpenShiftRowKey)])
    }, [selectedShifts, selectedOpenShifts]);

    useEffect(() => {
        if (searchQuery === ""){
            setFilteredListItems(originalParsedListItems);
            return;
        }
        const lowerCaseSearchQuery = searchQuery.toLowerCase();
        setFilteredListItems(originalParsedListItems.filter(x => x.searchIndex.includes(lowerCaseSearchQuery)));
    }, [searchQuery]);
    
    useEffect(() => {
        const updatedListItems = Helpers.toListView(monthlySchedule);
        setOriginalParsedListItems(updatedListItems);
        setFilteredListItems(updatedListItems);
    }, [JSON.stringify(monthlySchedule)]);
    return (
        <div className="listview-root">
            <TableHeader
                isDisplaySegmentInfos={isDisplaySegmentInfos}
                onChangeIsDisplaySegmentInfos={setIsDisplaySegmentInfos}
                onChangeSearchQuery={setSearchQuery}
            />
            <Table
                listItems={filteredListItems}
                monthlySchedule={monthlySchedule}
                handleShiftClick={handleShiftClick}
                handleMultiSelectShift={handleMultiSelectShift}
                handleMultiSelectOpenShift={handleMultiSelectOpenShift}
                checkedKeys={checkedKeys}
                isRowSelectionDisabled={isRowSelectionDisabled}
                fillAvailableHeight={fillAvailableHeight}
                height={height}
                isDisplaySegmentInfos={isDisplaySegmentInfos}
            />
        </div>
    );
};
export default BillboardListView;
